import type { CSSProperties } from 'react'
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/shared/components/ui/toast'
import { useToast } from '@/shared/hooks/use-toast'

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} data-testid={id ? `toast-${id}` : undefined} {...props}>
            <div style={styles.content}>
              {title ? <ToastTitle>{title}</ToastTitle> : null}
              {description ? <ToastDescription>{description}</ToastDescription> : null}
            </div>
            {action}
            <ToastClose data-testid={id ? `toast-dismiss-button-${id}` : 'toast-dismiss-button'} />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}

const styles: Record<string, CSSProperties> = {
  content: {
    display: 'grid',
    gap: '4px',
  },
}
